import { initContainer } from "./container/root";
import config from '../config';
import ErrorReportingService from './error-reporting.service';
import { initIframeService } from "./iframe-service/iframe-service";
import clarityService from "./clarity.service";

let runOnce = false;

export default function startup() : Promise<void> {
    console.log(`[rms-client] version ${config.verion}`);

    return new Promise(async (resolve) => {
        if (runOnce) {
            console.error(`attempt to call startup method more than once!!!`);
            return;
        }
        runOnce = true;

        /** determining api url and overriding config.apiUrl:
         *  - default is app.returngo.ai
         *  - 1. override the value by query string param (mainly for debug purposes) - this can only work NOT from an iframe
         *  - 2. override by value from parent frame (initIframeService)  */

        const searchParams = new URLSearchParams(window.location?.search);
        config.apiUrl = searchParams.get('apiUrl') ?? config.apiUrl;

        const service = initIframeService();
        const errorReportingService = new ErrorReportingService();
        const [apiUrl, rmsApiUrl] = await Promise.all([service.getApiUrl(), service.getRmsApiUrl()]);
        config.apiUrl = apiUrl ?? config.apiUrl;
        config.rmsApiUrl = rmsApiUrl ?? config.rmsApiUrl;
        initContainer(service, errorReportingService, config.apiUrl, config.rmsApiUrl);

        clarityService.setConsent(true);

        // Initialize error handling service
        errorReportingService.initialize();
        resolve();
    })
};
